import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const AlertYellowIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 16, height = 16, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M17 3.34001C18.5083 4.21087 19.7629 5.46054 20.6398 6.96532C21.5167 8.47009 21.9854 10.1778 21.9994 11.9194C22.0135 13.6609 21.5725 15.376 20.72 16.8947C19.8676 18.4135 18.6332 19.6832 17.1392 20.5783C15.6452 21.4734 13.9434 21.9628 12.2021 21.9981C10.4608 22.0333 8.74055 21.6132 7.21155 20.7793C5.68256 19.9453 4.39787 18.7265 3.48467 17.2435C2.50876 15.6587 2.0286 13.8533 2 12C2.02839 10.1604 2.50131 8.36796 3.46364 6.79101C4.36373 5.31604 5.63065 4.09947 7.14089 3.2599C8.65113 2.42033 10.3531 1.98641 12.081 2.00045C13.8089 2.01449 15.5036 2.47601 17 3.34001Z"
          fill="#FFC53D"
        />
        <path
          d="M12.0098 14.9994L11.8828 15.0064C11.6397 15.0353 11.4157 15.1524 11.2532 15.3354C11.0906 15.5184 11.0009 15.7547 11.0009 15.9994C11.0009 16.2442 11.0906 16.4804 11.2532 16.6635C11.4157 16.8465 11.6397 16.9635 11.8828 16.9924L11.9998 16.9994L12.1268 16.9924C12.3698 16.9635 12.5938 16.8465 12.7563 16.6635C12.9189 16.4804 13.0086 16.2442 13.0086 15.9994C13.0086 15.7547 12.9189 15.5184 12.7563 15.3354C12.5938 15.1524 12.3698 15.0353 12.1268 15.0064L12.0098 14.9994ZM11.9998 6.99942C11.7548 6.99945 11.5184 7.08938 11.3354 7.25214C11.1523 7.41489 11.0354 7.63917 11.0068 7.88242L10.9998 7.99942V11.9994L11.0068 12.1164C11.0357 12.3595 11.1527 12.5835 11.3357 12.746C11.5187 12.9085 11.755 12.9983 11.9998 12.9983C12.2445 12.9983 12.4808 12.9085 12.6638 12.746C12.8468 12.5835 12.9638 12.3595 12.9928 12.1164L12.9998 11.9994V7.99942L12.9928 7.88242C12.9641 7.63917 12.8472 7.41489 12.6641 7.25214C12.4811 7.08938 12.2447 6.99945 11.9998 6.99942Z"
          fill="white"
        />
      </svg>
    );
  },
);
